import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import LeadModalProvider from './components/LeadModalProvider.jsx';
import CompareProvider from './components/CompareProvider.jsx';
import FindCourseProvider from './components/FindCourseProvider.jsx';
import './styles.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <LeadModalProvider>
        <CompareProvider>
          <FindCourseProvider>
            <App />
          </FindCourseProvider>
        </CompareProvider>
      </LeadModalProvider>
    </BrowserRouter>
  </React.StrictMode>
);
